import { BrowserRouter, Routes, Route } from "react-router-dom";

import MobileHeader from "./components/MobileHeader";
import BottomNav from "./components/BottomNav";
import ProtectedRoute from "./components/ProtectedRoute";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Subjects from "./pages/Subjects";
import Teachers from "./pages/Teachers";
import Classes from "./pages/Classes";
import Timetable from "./pages/Timetable";
import Arrangements from "./pages/Arrangements";
import TeacherArrangement from "./pages/TeacherArrangement";
import ArrangementHistory from "./pages/ArrangementHistory";

// Admin pages (all in pages folder directly)
import AdminDashboard from "./pages/AdminDashboard";
import TeacherTimetable from "./pages/TeacherTimetable";
import ClassTimetable from "./pages/ClassTimetable";
import TeacherWorkload from "./pages/TeacherWorkload";
import TeacherReport from "./pages/TeacherReport";

// Protected route wrapper for admin
const ProtectedAdminRoute = ({ children }) => {
  const isAdminLoggedIn = sessionStorage.getItem('isAdminLoggedIn');
  if (!isAdminLoggedIn) {
    window.location.href = '/login';
    return null;
  }
  return children;
};

function App() {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const isAdminLoggedIn = sessionStorage.getItem('isAdminLoggedIn') === 'true';

  // Check if we're on an admin route
  const isAdminRoute = window.location.pathname.startsWith('/admin');

  // Show MobileHeader and BottomNav only for school routes (not admin)
  const showSchoolNav = isLoggedIn && !isAdminRoute;

  return (
    <BrowserRouter>
      {showSchoolNav && <MobileHeader />}

      <div
        style={{
          padding: showSchoolNav ? "15px" : "0",
          paddingBottom: showSchoolNav ? "80px" : "0",
          minHeight: "100vh",
        }}
      >
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          
          {/* School routes - protected */}
          <Route path="/" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/subjects" element={
            <ProtectedRoute>
              <Subjects />
            </ProtectedRoute>
          } />
          
          <Route path="/teachers" element={
            <ProtectedRoute>
              <Teachers />
            </ProtectedRoute>
          } />
          
          <Route path="/classes" element={
            <ProtectedRoute>
              <Classes />
            </ProtectedRoute>
          } />
          
          <Route path="/timetable" element={
            <ProtectedRoute>
              <Timetable />
            </ProtectedRoute>
          } />
          
          <Route path="/arrangements" element={
            <ProtectedRoute>
              <Arrangements />
            </ProtectedRoute>
          } />
          
          <Route path="/teacher-arrangement" element={
            <ProtectedRoute>
              <TeacherArrangement />
            </ProtectedRoute>
          } />
          
          <Route path="/arrangement-history" element={
            <ProtectedRoute>
              <ArrangementHistory />
            </ProtectedRoute>
          } />

          {/* Admin routes - protected */}
          <Route path="/admin" element={
            <ProtectedAdminRoute>
              <AdminDashboard />
            </ProtectedAdminRoute>
          } />
          
          <Route path="/admin/teacher-timetable" element={
            <ProtectedAdminRoute>
              <TeacherTimetable />
            </ProtectedAdminRoute>
          } />
          
          <Route path="/admin/class-timetable" element={
            <ProtectedAdminRoute>
              <ClassTimetable />
            </ProtectedAdminRoute>
          } />
          
          <Route path="/admin/teacher-workload" element={
            <ProtectedAdminRoute>
              <TeacherWorkload />
            </ProtectedAdminRoute>
          } />
          
          <Route path="/admin/teacher-report" element={
            <ProtectedAdminRoute>
              <TeacherReport />
            </ProtectedAdminRoute>
          } />
          
          {/* Redirect any unknown admin sub-routes to admin dashboard */}
          <Route path="/admin/*" element={
            <ProtectedAdminRoute>
              <AdminDashboard />
            </ProtectedAdminRoute>
          } />
        </Routes>
      </div>

      {showSchoolNav && <BottomNav />}
    </BrowserRouter>
  );
}

export default App;